const navValues = {
  loggedIn: "LoggedIn",
  loggedOut: "LoggedOut",
};

export default navValues;
